export default function Modal() {
  return {
    marginXS: 16,
    colorBgMask: "rgba(33, 43, 54, 0.8)",
    fontSizeHeading5: 24
    // colorTextHeading: "#EE6C4D",
  }
}
